import { countyIsKirinyaga } from "@/utils/vue_helpers";
import { routes } from "./routes";
import {
  getPortalMode,
  isProfessionalUser,
  PORTAL_MODE_PROFESSIONAL,
} from "@/utils/permissions";

function getDashboardLink() {
  if (isProfessionalUser() && getPortalMode() === PORTAL_MODE_PROFESSIONAL) {
    return {
      text: "Dashboard",
      icon: "mdi-view-dashboard",
      route: routes.professionalDashboard,
    };
  }
  return {
    text: "Dashboard",
    icon: "mdi-card-multiple",
    route: routes.userAccountDetails,
  };
}

export function getDashboardLinks() {
  const links = [
    getDashboardLink(),

    {
      text: "View Bills And Receipts",
      icon: "mdi-receipt-text",
      route: routes.viewBills,
    },

    {
      text: "My Businesses",
      icon: "mdi-briefcase",
      route: routes.viewBusinesses,
    },

    {
      text: "My Plots",
      icon: "mdi-home-city",
      route: routes.viewProperties,
    },

    {
      text: "My Rates Statements",
      icon: "mdi-home-analytics",
      route: routes.propertyRateStatement,
    },

    {
      text: "My Scheme Plans",
      icon: "mdi-map-marker-multiple",
      children: [
        {
          text: "Query / Register Property",
          icon: "mdi-map-marker-plus",
          route: routes.viewSchemePlanProperties,
        },
        {
          text: "Query Applications",
          icon: "mdi-database-search",
          route: routes.queryMyPropertySchemePlanApplications,
        },
        {
          text: "Create Application",
          icon: "mdi-pencil",
          route: routes.createSchemePlanApplication,
        },
        {
          text: "Query Client Applications",
          icon: "mdi-database-search",
          route: routes.queryClientSchemePlanApplications,
        },
      ],
    },

    {
      text: "My Vehicles",
      icon: "mdi-car",
      route: routes.viewVehicles,
    },
    {
      text: "My Houses/Stalls",
      icon: "mdi-city",
      route: routes.viewHouses,
    },

    {
      text: "My Buildings",
      icon: "mdi-office-building",
      route: routes.viewClientBuildings,
    },

    {
      text: "My Self Help Groups",
      icon: "mdi-spa",
      route: routes.viewSelfHelpGroups,
    },

    {
      text: "Building Applications",
      icon: "mdi-wrench",
      //route: routes.viewBuildings,
      children:[
        {
          text: "Create Application",
          icon: "mdi-pencil",
          route: routes.createBuildingApp,
        },

        {
          text: "Query Applications",
          icon: "mdi-database-search",
          route: routes.viewBuildings,
        },
        {
          text: "Query Enforcement",
          icon: "mdi-database-search",
          route: routes.viewEnforcements,
        },
        {
          text: "Query Renovations",
          icon: "mdi-hammer-wrench",
          route: routes.viewRenovations,
        },
        {
          text: "Query Demolitions",
          icon: "mdi-hammer",
          route: routes.viewDemolitions,
        },
        {
          text: "My Drafts",
          icon: "mdi-file-arrow-left-right",
          route: routes.viewDrafts,
        },
        
      ]
    },

    //ViewClientBuildings

    {
      text: "My Profile",
      icon: "mdi-account",
      route: routes.userProfileView,
    },
  ];

  if (!countyIsKirinyaga.value) {
    links.push({
      text: "Change Password",
      icon: "mdi-lock",
      route: routes.userLoggedInResetPassword,
    });
  }

  return links;
}
